import React, { useState } from 'react';
import Icon from '../../Icon';
import clsx from 'clsx';
import EditorString from '../../EditorString';

const DescriptionFaq = ({ faqTitle, faqContent }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="faq-item">
      <button
        className="faq-item__trigger"
        aria-expanded={isOpen}
        onClick={() => setIsOpen(!isOpen)}
      >
        <span className="faq-item__trigger-title">{faqTitle}</span>
        <Icon
          size={24}
          name="Caret-Down"
          className={clsx(
            'faq-item__trigger-icon',
            isOpen && 'faq-item__trigger-icon--open'
          )}
        />
      </button>
      <div
        className={clsx(
          'faq-item__content-wrapper',
          isOpen && 'faq-item__content-wrapper--open'
        )}
      >
        <div className="faq-item__content">
          <div className="faq-item__content-container">
            {faqContent && <EditorString value={faqContent.value} />}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DescriptionFaq;
